export * from './actions'
export * from './selectors'
export * from './types'
import api from './reducer'

let { reducer, reducerPath, middleware } = api
export { reducer, reducerPath, middleware }
